<template>
    <component :is="htmlTag" :style="style">
        <slot/>
        <grid-viewport-listener v-model="size"/>
    </component>
</template>

<script>
export default {
    name: 'grid-item',
    props: {
        area: {
            type: String,
            default: null
        },
        htmlTag: {
            type: String,
            default: 'div'
        },
        col_start: {
            type: String,
            default: null
        },
        row_start: {
            type: String,
            default: null
        },
        col_end: {
            type: String,
            default: null
        },
        row_end: {
            type: String,
            default: null
        },
        width: {
            type: String,
            default: "1"
        },
        mobileWidth: {
            type: String
        },
        height: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            size: {}
        }
    },
    computed: {
        style () {
            if (this.area) {
                return {
                    gridArea: this.area
                }
            }
            var width = this.width
            if (this.size.isPhone && this.mobileWidth) {
                width = this.mobileWidth
            }

            // no area defined
            const areaWidth = width ? `span ${width}` : null
            const areaHeight = this.height ? `span ${this.height}` : null
            return {
                gridColumnStart: this.col_start,
                gridColumnEnd: this.col_end || areaWidth,
                gridRowStart: this.row_start,
                gridRowEnd: this.row_end || areaHeight
            }
        }
    }
}
</script>